export const LOGIN_FORM = 'login';
export const REGISTER_FORM = 'register';
export const PROFILE_FORM = 'profile';
export const FORGOT_PASSWORD = 'forgot_password';
export const CONFIRMATION = 'confirmation';
